import React, { useState, useEffect } from 'react';
import '../styles/ProductHero.css';
import QuoteModal from './QuoteModal';
// Import images for right side slider
import img1 from '../assets/bg1.png';
import img2 from '../assets/bg2.png';
import img3 from '../assets/bg3.png';
import img4 from '../assets/bg4.png';
import img5 from '../assets/bg5.png';
import bgr from '../assets/pr13.png';

const ProductHero = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [fade, setFade] = useState(true);
  const [isQuoteModalOpen, setIsQuoteModalOpen] = useState(false);

  const openQuoteModal = () => {
    setIsQuoteModalOpen(true);
  };

  const closeQuoteModal = () => {
    setIsQuoteModalOpen(false);
  };

  // Right side images for slider
  const rightImages = [
    { id: 1, image: img1 },
    { id: 2, image: img2 },
    { id: 3, image: img3 },
    { id: 4, image: img4 },
    { id: 5, image: img5 },
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setFade(false);
      setTimeout(() => {
        setCurrentSlide((prev) => (prev + 1) % rightImages.length);
        setFade(true);
      }, 500);
    }, 5000);

    return () => clearInterval(interval);
  }, [rightImages.length]);

  return (
    <>
      <section id="product-hero" className="product-hero-section">
        
        {/* Solid Background - No Background Images */}
        <div className="product-hero-background-solid">
          <div className="product-hero-overlay-solid"></div>
        </div>

        <div className="product-hero-container">
          
          {/* Left Content */}
          <div className="product-hero-content">
            <div className="product-hero-badge">
              <span className="product-hero-badge-text">Premium Quality</span>
              <span className="product-hero-badge-icon">✓</span>
            </div>
            
            <h1 className="product-hero-title">
              Advanced <span className="product-hero-highlight">Rechargeable</span><br />
              Hearing Aid Solutions
            </h1>
            
            <p className="product-hero-description">
              Discover our range of QuickFit hearing aids designed for superior sound quality, 
              all-day comfort, and modern convenience. Perfect for clinics, distributors, 
              and hearing care professionals across India.
            </p>
            
            <div className="product-hero-features">
              <div className="product-hero-feature">
                <span className="product-hero-feature-icon">✓</span>
                <span>Made in India</span>
              </div>
              <div className="product-hero-feature">
                <span className="product-hero-feature-icon">✓</span>
                <span>ISO Certified</span>
              </div>
              <div className="product-hero-feature">
                <span className="product-hero-feature-icon">✓</span>
                <span>Faster Delivery</span>
              </div>
              <div className="product-hero-feature">
                <span className="product-hero-feature-icon">✓</span>
                <span>Bulk Order Available</span>
              </div>
            </div>
            
            {/* Single CTA Button - Only Request B2B Quote */}
            <div className="product-hero-buttons">
              <button onClick={openQuoteModal} className="product-hero-btn-primary">
                Request B2B Quote
                <svg className="product-hero-btn-icon" viewBox="0 0 24 24" fill="none">
                  <path d="M5 12H19M19 12L13 6M19 12L13 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </button>
            </div>
            
           
          </div>
          
          {/* Right Image Slider with Fading Effect */}
          <div className="product-hero-image-wrapper">
            <div className="product-hero-image-container">
              {rightImages.map((img, index) => (
                <div
                  key={img.id}
                  className={`product-hero-slide-image ${index === currentSlide ? 'active' : ''} ${fade && index === currentSlide ? 'fade-in' : ''}`}
                >
                  <img 
                    src={img.image} 
                    alt={`Product Slide ${index + 1}`}
                    className="product-hero-image"
                  />
                </div>
              ))}
            </div>
          </div>
          
        </div>
      </section>

      {/* Quote Modal */}
      <QuoteModal isOpen={isQuoteModalOpen} onClose={closeQuoteModal} />
    </>
  );
};

export default ProductHero;